var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInReplyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7682 7.38175C9.94393 7.55749 9.94393 7.84241 9.7682 8.01815L7.79853 9.98782C7.68137 10.105 7.68137 10.2949 7.79853 10.4121C7.91568 10.5292 8.10563 10.5292 8.22279 10.4121L10.1925 8.44241C10.6025 8.03236 10.6025 7.36754 10.1925 6.95749L8.22279 4.98782C8.10563 4.87066 7.91568 4.87066 7.79853 4.98782C7.68137 5.10498 7.68137 5.29493 7.79853 5.41208L9.7682 7.38175Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 1.5C1.63432 1.5 1.5 1.63431 1.5 1.8V6.54995C1.5 7.37838 2.17157 8.04995 3 8.04995H10C10.1657 8.04995 10.3 7.91564 10.3 7.74995C10.3 7.58427 10.1657 7.44995 10 7.44995H3C2.50294 7.44995 2.1 7.04701 2.1 6.54995V1.8C2.1 1.63431 1.96569 1.5 1.8 1.5Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInReplyArrow);
export default __webpack_public_path__ + "static/media/inReplyArrow.e864130d9c4dcbfa957e291ebfcd9d35.svg";
export { ForwardRef as ReactComponent };